import React from 'react';
import { Landing } from './pages/Landing';
export function App() {
  return <Landing data-id="element-0" data-mp="35cbzcksy47af" />;
}